/**
 * @author       [Tim Vermaelen]
 * @date         [2025]
 * @link         [http://www.adequatelygood.com/JavaScript-Module-Pattern-In-Depth.html]
 * @namespace    [Blastic.Dom]
 * @requires     [jQuery, Blastic]
 * @revision     [0.1]
 */

// @param (ns): window.Blastic
window.Blastic = (function (ns) {

    // 1. ECMA-262/5
    'use strict';

    // 2. CONFIGURATION
    const cfg = {
        cache: {
            iframe: 'iframe'
        }
    };

    // 3. FUNCTIONS OBJECT
    ns.Dom = {

        revision: 0.1,

        init: function () {
            this.cacheItems();
            this.activate();
        },

        cacheItems: function () {
            const { cache } = cfg;

            this.iframes = document.querySelectorAll(cache.iframe);
        },

        activate: function () {
            this.addIframeTitles();
        },

        addIframeTitles: function () {
            this.iframes.forEach(iframe => {
                // Skip if iframe already has a title
                if (iframe.hasAttribute('title')) return;

                try {
                    const url = new URL(iframe.src);
                    let hostname = url.hostname;

                    // Strip 'www.' if present
                    hostname = hostname.replace(/^www\./, '');

                    // Remove domain extension (e.g., .com, .org, .co.uk)
                    const parts = hostname.split('.');
                    if (parts.length > 2) {
                        // Keep only the second-level domain (e.g., sub.domain.co.uk => domain)
                        hostname = parts[parts.length - 2];
                    } else if (parts.length === 2) {
                        // domain.com => domain
                        hostname = parts[0];
                    }

                    // Set the title attribute
                    iframe.setAttribute('title', `Embedded content from ${hostname}`);
                } catch (e) {
                    iframe.setAttribute('title', 'generated iframe');
                }
            });
        }

    }

    // 4. NAMESPACE
    return ns;

})(window.Blastic || {});

